import React from 'react';
import { Field, FieldProps } from 'formik';
import { FormField } from 'components';
import {
    NewPackFormFields,
    NewPackFormVisibleFieldKeys,
} from '../NewPack.types';
import {
    newPackFieldDescriptions,
    newPackFieldPlaceholder,
    newPackFieldTitles,
} from '../NewPack.constants';
import { descriptionComponent, fieldComponents } from './NewPackForm';

export interface InputLayoutProps {
    fieldKey: NewPackFormVisibleFieldKeys;
    isDescriptionOnTop?: boolean;
}

export const InputLayout: React.FC<InputLayoutProps> = ({
    fieldKey,
    isDescriptionOnTop,
}) => {
    return (
        <Field
            name={fieldKey}
            render={(
                formikProps: FieldProps<NewPackFormFields>,
            ): JSX.Element => (
                <FormField
                    {...formikProps}
                    key={`form-field-${fieldKey}`}
                    title={newPackFieldTitles[fieldKey]}
                    description={newPackFieldDescriptions[fieldKey]}
                    placeholder={newPackFieldPlaceholder[fieldKey]}
                    descriptionComponent={descriptionComponent[fieldKey]}
                    component={fieldComponents[fieldKey]}
                    isDescriptionOnTop={isDescriptionOnTop}
                />
            )}
        />
    );
};
